import {TextField} from '@mui/material';
import styled from 'styled-components/macro';

const StyledInput = styled(TextField)`
  margin-bottom: 18px;
  input:read-only {
    font-weight: 100;
  }
  &.short-field {
    & .MuiInputBase-root {
      width: 65px;
    }
  }
  &.helperText__unsetMarginLeft {
    & .MuiFormHelperText-root {
      margin-left: 0;
    }
  }
`;

export {StyledInput};
